import { History } from "history";

import {
  QuestionDto,
  CreateQuestionRequest,
  UpdateQuestionRequest,
} from "../../interfaces";
import { MediaDto } from "../../interfaces/media";
import { QuestionModelEnum } from "../../enums";

export const GET_QUESTIONS_BY_LESSON = "GET_QUESTIONS_BY_LESSON";
export const GET_QUESTIONS_BY_LESSON_SUCCESS: any =
  "GET_QUESTIONS_BY_LESSON_SUCCESS";
export const GET_QUESTIONS_BY_LESSON_ERROR: any =
  "GET_QUESTIONS_BY_LESSON_ERROR";

//#region Get Questions by Lesson

export interface GetQuestionsByLessonAction {
  type: typeof GET_QUESTIONS_BY_LESSON;
  payload: { lessonId: string; model?: QuestionModelEnum };
}

export interface GetQuestionsByLessonSuccessAction {
  type: typeof GET_QUESTIONS_BY_LESSON_SUCCESS;
  payload: QuestionDto[];
}

export interface GetQuestionsByLessonErrorAction {
  type: typeof GET_QUESTIONS_BY_LESSON_ERROR;
  payload: any;
}

//#endregion

//#region Get Question

export const GET_QUESTION = "GET_QUESTION";
export const GET_QUESTION_SUCCESS: any = "GET_QUESTION_SUCCESS";
export const GET_QUESTION_ERROR: any = "GET_QUESTION_ERROR";

export interface GetQuestionAction {
  type: typeof GET_QUESTION;
  payload: {
    id: string;
    history: History;
  };
}

export interface GetQuestionSuccessAction {
  type: typeof GET_QUESTION_SUCCESS;
  payload: QuestionDto;
}

export interface GetQuestionErrorAction {
  type: typeof GET_QUESTION_ERROR;
  payload: any;
}
//#endregion

//#region Add Question

export const ADD_QUESTION = "ADD_QUESTION";
export const ADD_QUESTION_SUCCESS: any = "ADD_QUESTION_SUCCESS";
export const ADD_QUESTION_ERROR: any = "ADD_QUESTION_ERROR";

export interface AddQuestionAction {
  type: typeof ADD_QUESTION;
  payload: {
    request: CreateQuestionRequest;
    history: History;
  };
}

export interface AddQuestionSuccessAction {
  type: typeof ADD_QUESTION_SUCCESS;
  payload: null;
}

export interface AddQuestionErrorAction {
  type: typeof ADD_QUESTION_ERROR;
  payload: any;
}
//#endregion

//#region Update Question

export const UPDATE_QUESTION = "UPDATE_QUESTION";
export const UPDATE_QUESTION_SUCCESS: any = "UPDATE_QUESTION_SUCCESS";
export const UPDATE_QUESTION_ERROR: any = "UPDATE_QUESTION_ERROR";

export interface UpdateQuestionAction {
  type: typeof UPDATE_QUESTION;
  payload: {
    id: string;
    request: UpdateQuestionRequest;
    history: History;
  };
}

export interface UpdateQuestionSuccessAction {
  type: typeof UPDATE_QUESTION_SUCCESS;
  payload: null;
}

export interface UpdateQuestionErrorAction {
  type: typeof UPDATE_QUESTION_ERROR;
  payload: any;
}
//#endregion

//#region Delete Question

export const DELETE_QUESTION_CONSENT: any = "DELETE_QUESTION_CONSENT";
export const DELETE_QUESTION = "DELETE_QUESTION";
export const DELETE_QUESTION_SUCCESS: any = "DELETE_QUESTION_SUCCESS";
export const DELETE_QUESTION_ERROR: any = "DELETE_QUESTION_ERROR";

export interface DeleteQuestionConsentAction {
  type: typeof DELETE_QUESTION_CONSENT;
  payload: string;
}

export interface DeleteQuestionAction {
  type: typeof DELETE_QUESTION;
  payload: {
    id: string;
    history: History;
  };
}

export interface DeleteQuestionSuccessAction {
  type: typeof DELETE_QUESTION_SUCCESS;
  payload: null;
}

export interface DeleteQuestionErrorAction {
  type: typeof DELETE_QUESTION_ERROR;
  payload: any;
}
//#endregion

//#region Upload Question Home Image

export const UPLOAD_QUESTION_DISPLAY_IMAGE = "UPLOAD_QUESTION_DISPLAY_IMAGE";
export const UPLOAD_QUESTION_DISPLAY_IMAGE_SUCCESS: any =
  "UPLOAD_QUESTION_DISPLAY_IMAGE_SUCCESS";
export const UPLOAD_QUESTION_DISPLAY_IMAGE_ERROR: any =
  "UPLOAD_QUESTION_DISPLAY_IMAGE_ERROR";

export interface UploadQuestionDisplayImageAction {
  type: typeof UPLOAD_QUESTION_DISPLAY_IMAGE;
  payload: {
    file: File;
    history: History;
    questionId?: string;
  };
}
export interface UploadQuestionDisplayImageSuccessAction {
  type: typeof UPLOAD_QUESTION_DISPLAY_IMAGE_SUCCESS;
  payload: MediaDto;
}

export interface UploadQuestionDisplayImageErrorAction {
  type: typeof UPLOAD_QUESTION_DISPLAY_IMAGE_ERROR;
  payload: any;
}
//#endregion

//#region add edit question modal
export const TOGGLE_ADD_EDIT_QUESTION_MODAL: any =
  "TOGGLE_ADD_EDIT_QUESTION_MODAL";

export interface ToggleAddEditQuestionModalAction {
  type: typeof TOGGLE_ADD_EDIT_QUESTION_MODAL;
  payload: any;
}
//#endregion

//#region Upload Question  Image

export const UPLOAD_QUESTION_IMAGE = "UPLOAD_QUESTION_IMAGE";
export const UPLOAD_QUESTION_IMAGE_SUCCESS: any =
  "UPLOAD_QUESTION_IMAGE_SUCCESS";
export const UPLOAD_QUESTION_IMAGE_ERROR: any = "UPLOAD_QUESTION_IMAGE_ERROR";

export interface UploadQuestionImageAction {
  type: typeof UPLOAD_QUESTION_IMAGE;
  payload: {
    file: File;
    history: History;
    tempId: string;
  };
}
export interface UploadQuestionImageSuccessAction {
  type: typeof UPLOAD_QUESTION_IMAGE_SUCCESS;
  payload: { id: string; url: string; tempId: number };
}

export interface UploadQuestionImageErrorAction {
  type: typeof UPLOAD_QUESTION_IMAGE_ERROR;
  payload: any;
}
//#endregion

//#region Toggle Question State

export const TOGGLE_QUESTION_STATE_CONSENT: any =
  "TOGGLE_QUESTION_STATE_CONSENT";
export const TOGGLE_QUESTION_STATE = "TOGGLE_QUESTION_STATE";
export const TOGGLE_QUESTION_STATE_SUCCESS: any =
  "TOGGLE_QUESTION_STATE_SUCCESS";
export const TOGGLE_QUESTION_STATE_ERROR: any = "TOGGLE_QUESTION_STATE_ERROR";

export interface ToggleQuestionStateConsentAction {
  type: typeof TOGGLE_QUESTION_STATE_CONSENT;
  payload: string;
}

export interface ToggleQuestionStateAction {
  type: typeof TOGGLE_QUESTION_STATE;
  payload: {
    id: string;
    history: History;
  };
}

export interface ToggleQuestionStateSuccessAction {
  type: typeof TOGGLE_QUESTION_STATE_SUCCESS;
  payload: { id: string };
}

export interface ToggleQuestionStateErrorAction {
  type: typeof TOGGLE_QUESTION_STATE_ERROR;
  payload: any;
}
//#endregion

// Export a union type that represents all possible actions
export type ActionTypes =
  | GetQuestionsByLessonAction
  | GetQuestionsByLessonSuccessAction
  | GetQuestionsByLessonErrorAction
  | GetQuestionAction
  | GetQuestionSuccessAction
  | GetQuestionErrorAction
  | AddQuestionAction
  | AddQuestionSuccessAction
  | AddQuestionErrorAction
  | UpdateQuestionAction
  | UpdateQuestionSuccessAction
  | UpdateQuestionErrorAction
  | DeleteQuestionAction
  | DeleteQuestionSuccessAction
  | DeleteQuestionErrorAction
  | UploadQuestionDisplayImageAction
  | UploadQuestionDisplayImageSuccessAction
  | UploadQuestionDisplayImageErrorAction
  | ToggleAddEditQuestionModalAction
  | ToggleQuestionStateAction
  | ToggleQuestionStateSuccessAction
  | ToggleQuestionStateErrorAction;
